import { IBarrierActionData } from 'apis/ActionTracker/getBarrierActionTracker'
import { MRT_ColumnDef, MRT_TableInstance } from 'material-react-table'
import * as _ from 'lodash'

export const ATTableInitialVisibility = (
  columns: MRT_ColumnDef<IBarrierActionData>[],
  hiddenColumns: string[]
): { [key: string]: boolean } => {
  const initialColumnVisibility: { [key: string]: boolean } = columns.reduce((acc, col) => {
    acc[col.accessorKey as string] = !hiddenColumns.includes(col.accessorKey as string)
    // acc[col.accessorKey as string] = false
    return acc
  }, {} as { [key: string]: boolean })
  return initialColumnVisibility
}

export function ValueOrDefault(value: any, defaultValue: string = '--') {
  return _.isEmpty(value) ? defaultValue : (value as string)
}

export function ValueOrDefaultString(value: string | string[] | undefined) {
  return value ? (value as string) : '--'
}

export function getTextColor(value: string) {
  switch (value?.toLowerCase()) {
    case 'low':
      return '#5BBE7D'
    case 'medium':
      return '#F3C413'
    case 'high':
      return '#FF5056'
    default:
      return '#101737'
  }
}

export const extractTableColumnConfig = (
  mrtTable: MRT_TableInstance<IBarrierActionData>
): { is_visible: boolean; name: string; key: string }[] => {
  const columnOrder = mrtTable?.getState().columnOrder
  const columnVisibility = mrtTable?.getState().columnVisibility
  if (!columnOrder || !columnVisibility) {
    return []
  }

  // Create a column config based on the column order and visibility
  const columnConfig = columnOrder
    ?.map((columnKey) => {
      const column = mrtTable?.getColumn(columnKey)
      if (column && column.columnDef.header) {
        return {
          is_visible: columnVisibility[columnKey] ?? true,
          name: column.columnDef.header as string,
          key: columnKey,
        }
      }
    })
    .filter((col) => col) as { is_visible: boolean; name: string; key: string }[]
  // add column not in columnOrder
  const allColumns = mrtTable?.getAllColumns()
  allColumns.forEach((column) => {
    if (!columnConfig.find((col) => col?.key === column.columnDef.accessorKey)) {
      if (!column.columnDef.accessorKey || !column.columnDef.header) return
      columnConfig.push({
        is_visible: columnVisibility[column.columnDef.accessorKey as string] ?? true,
        name: column.columnDef.header as string,
        key: column.columnDef.accessorKey as string,
      })
    }
  })
  return columnConfig
}

export const updateMrtStateFromApi = (
  mrtTable: MRT_TableInstance<IBarrierActionData>,
  columns: { is_visible: boolean; name: string; key: string }[],
  hiddenColumns: string[] = []
) => {
  let columnOrder: string[] = []
  let columnVisibility: { [key: string]: boolean } = {}
  if (columns.length > 0) {
    columnOrder = columns.map((col) => col.key)

    columnVisibility = columns.reduce((acc, col) => {
      acc[col.key] = col.is_visible
      return acc
    }, {} as { [key: string]: boolean })

  } else {

    columnOrder = mrtTable.getState().columnOrder || []

    columnVisibility = mrtTable.getAllColumns().reduce((acc, col) => {
      acc[col.columnDef.accessorKey as string] = !hiddenColumns.includes(
        col.columnDef.accessorKey as string
      )
      return acc
    }, {} as { [key: string]: boolean })

  }

  mrtTable?.setColumnOrder(columnOrder)
  mrtTable?.setColumnVisibility(columnVisibility)
}


export const highlightInput = (compRef: React.RefObject<HTMLDivElement | HTMLTextAreaElement>) =>{
    if (compRef.current) {
      compRef.current.classList.add('highlight-flash')
      setTimeout(() => {
        compRef.current?.classList.remove('highlight-flash')
      }, 3000)
    }
  }